module.exports = __webpack_public_path__ + "static/media/Lato-Black.1233fdf1.ttf";